<template>
  <div class="emh-emico-overlay">
    <a class="emh-emico-overlay__link wb-link wb-link--standalone" @click="showModal = true"><slot></slot></a>
    <div class="emh-emico-overlay__modal-container">
      <ui-modal-window class="emh-emico-overlay__modal" :show="showModal" mode="info" @close="closeModal">
        <wb-modal-header></wb-modal-header>
        <wb-modal-content :headline.attr="$t(`dcp.${type}.title`)">
          <template v-if="type === 'wltp'">
            <p class="emh-emico-overlay__copy">
              {{ $t(`dcp.${type}.copy`) }}
            </p>
            <h4 class="emh-emico-overlay__subtitle">{{ $t(`dcp.${type}.subtitle`) }}</h4>
          </template>

          <div v-if="emicoData" class="emh-emico-overlay__emission-data">
            <div v-for="(emico, index) in emicoData" :key="index" class="emh-emico-overlay__emission-data-item">
              <span class="emh-emico-overlay__emission-data-label"
                >{{ emico.label }} <local-footnote-reference :text="emico.footnoteText" :context="context"
              /></span>
              <span class="emh-emico-overlay__emission-data-value">{{ emico.displayValue }}</span>
            </div>
          </div>

          <div v-if="type === 'nefz' && rating && showEcoRating" class="emh-emico-overlay__eco-rating">
            <wb-eco-rating class="emh-emico-overlay__eco-chart" :rating.attr="rating"></wb-eco-rating>
            <p class="emh-emico-overlay__eco-footnote">{{ $t('dcp.pdp.enrichedDetails.ecoFootnote') }}</p>
          </div>

          <local-footnote-container :context="context" />
        </wb-modal-content>
      </ui-modal-window>
    </div>
  </div>
</template>
<script lang="ts">
import { EmicoType } from '@dh-io-emh/config-types';
import { useFootnoteReference } from '../../../composables/footnote-reference.composable';
import { computed, defineComponent, PropType, ref, toRefs } from 'vue';
import { IEmicoData } from '@dh-io-emh/commerce-api/src/models/shared/ocb';
import UiModalWindow from '@dh-io-emh/ui/src/components/modalWindow/ModalWindow.vue';
import LocalFootnoteReference from '../../localFootnotes/localFootnoteReference.vue';
import LocalFootnoteContainer from '../../localFootnotes/localFootnoteContainer.vue';

export default defineComponent({
  name: 'EmicoOverlay',
  components: {
    UiModalWindow,
    LocalFootnoteContainer,
    LocalFootnoteReference,
  },
  props: {
    emicoData: {
      type: Array as PropType<IEmicoData[]>,
      required: true,
    },
    type: {
      type: String as PropType<EmicoType>,
      default: 'nefz',
    },
    showEcoRating: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const showModal = ref(false);
    const { generateReference } = useFootnoteReference('emicoOverlay');

    const context = generateReference();
    const { emicoData } = toRefs(props);

    const rating = computed(() => emicoData.value?.find((item: any) => item.id === '124T')?.displayValue);

    const closeModal = async () => {
      showModal.value = false;
    };

    return {
      showModal,
      closeModal,
      rating,
      generateReference,
      context,
    };
  },
});
</script>
<style lang="scss" scoped src="./overlay.scss"></style>
